import {TravelHubSBTConfigUsed} from "@domain/travel/travel-hub-sbt-config-used";
import {ListItem} from "@domain/common/list-view/list-item";
import {AbstractReferentiel} from "@domain/travel/abstract-referentiel";

/**
 * Représente une communauté d'une configuration SBT
 *
 * @author Laurent Convert
 * @date 14/11/2023
 */
export class Communaute implements ListItem,AbstractReferentiel {
	idCommunaute: number;
	libelle: string;
	sbtConfigUsed: TravelHubSBTConfigUsed;
	valeur: string;
	defaut: boolean = false;

	/**
	 * Constructeur
	 *
	 * @param dto Source
	 */
	constructor(dto?: any | Communaute) {
		if (dto) {
			Object.assign(this,dto);

			if (dto.sbtConfigUsed) {
				this.sbtConfigUsed = new TravelHubSBTConfigUsed(dto.sbtConfigUsed);
			}
		}
	}

	getKey(): number {
		return this.idCommunaute;
	}
}